import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  OutlineElement,
  SlotsController,
  LightDomStyles,
} from '@phase2/outline-core';
import { customElement, property, query } from 'lit/decorators.js';
import componentStyles from './outline-accordion-baseline-panel.css.lit';
import componentLightDomStyles from './outline-accordion-baseline-panel-light-dom.css.lit';
import '../../outline-icon-baseline/outline-icon-baseline';
/**
 * The OutlineAccordionBaselinePanel component
 * @element outline-accordion-baseline-panel
 */
@customElement('outline-accordion-baseline-panel')
export class OutlineAccordionBaselinePanel extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotsController(this);

  lightDomStyles = new LightDomStyles(
    this,
    componentLightDomStyles,
    this.tagName.toLowerCase()
  );

  @property({ type: String, attribute: 'aria-label' })
  ariaLabel: string;

  /**
   * Wether the panel is active/open.
   * Controlled by parent accordion component.
   */
  @property({ type: Boolean, reflect: true, attribute: true })
  active = false;

  /**
   * Used to provided a unique ID
   * for accordion component and accessibility purposes.
   */
  @property({ type: String, reflect: true })
  id: string = Math.floor(Math.random() * 10000).toString();

  @query('.accordion-panel--button')
  buttonRef: HTMLButtonElement;

  render(): TemplateResult {
    const isActive = this.active ? 'active' : 'inactive';

    return html`<section class="accordion-panel">
      <div class="accordion-panel--heading" @click=${this.passClick}>
        <div class="accordion-panel--label">
          ${this.slots.conditionalSlot('label', false)}
        </div>
        <button
          class="accordion-panel--button ${isActive}"
          id="${this.id}-button"
          aria-expanded=${this.active}
          aria-controls="${this.id}-info"
          @click=${this.setActive}
          aria-label="expand ${this.ariaLabel}"
        >
          <span class="accordion-panel--icon ${isActive}">
            <outline-icon-baseline
              library="system"
              name="${this.active ? 'eu-minus' : 'eu-plus'}"
              size="24px"
            ></outline-icon-baseline>
          </span>
        </button>
      </div>
      <div
        class="accordion-panel--content"
        role="region"
        aria-labelledby="${this.id}-button"
        id="${this.id}-info"
        aria-hidden="${!this.active}"
      >
        <slot></slot>
      </div>
    </section>`;
  }

  passClick(e: Event) {
    if ((e.target as Node).nodeName === 'BUTTON') {
      //bail
      return;
    } else {
      this.buttonRef.focus();
      this.setActive();
    }
  }
  setActive() {
    this.active = !this.active;
  }
}
